import React, { useContext, useState, useEffect, createContext } from 'react';

import { useAuth } from 'context/AuthContext';
import { useRestApi } from 'context/RestApiContext';

const MasterContext = createContext();

/**
 * マスタ情報プロバイダ
 * @param {*} 子要素
 * @returns マスタ情報プロバイダ
 */
export function MasterContextProvider({ children }) {
  const restApi = useRestApi();
  // 社員
  const [staff, setStaff] = useState([]);
  // 営業担当ソート順
  const [salesStaff, setSalesStaff] = useState([]);
  // 現場担当ソート順
  const [genbaStaff, setGenbaStaff] = useState([]);
  // プランナー
  const [planer, setPlaner] = useState([]);
  // ハウスメーカ
  const [houseMaker, setHouseMaker] = useState([]);
  // 集客要因区分
  const [channelKbn, setChannelKbn] = useState([]);
  // 集客要因
  const [channelCd, setChannelCd] = useState([]);
  // 工事種別
  const [kojiSyu, setKojiSyu] = useState([]);
  // ラベル
  const [label, setLabel] = useState([]);
  // 工程
  const [process, setProcess] = useState([]);
  // 事業
  const [jigyo, setJigyo] = useState([]);
  // ダッシュボードグループ
  const [dashboardGroup, setDashboardGroup] = useState([]);
  // 工事情報ステータス
  const [constructionStatus, setConstructionStatus] = useState([]);
  // 前受金の比率情報
  const [maeukeRates, setMaeukeRates] = useState([]);
  // 受付区分
  const [ukeType, setUkeType] = useState([]);
  // 特殊郵便番号
  const [originalPost, setOriginalPost] = useState([]);
  // ロボット工事種類
  const [robotTypes, setRobotTypes] = useState([]);

  useEffect(() => {
    restApi.get('/api/master/list', (data) => {
      // 社員
      setStaff(data['staff']);
      // 営業担当ソート順
      setSalesStaff(data['salesStaff']);
      // 現場担当ソート順
      setGenbaStaff(data['genbaStaff']);
      // プランナー（全社員を選択可能に変更）
      // setPlaner(data["staff"].filter(s => s["kbn"] === '1'));
      setPlaner(data['staff']);
      // ハウスメーカ
      setHouseMaker(data['company']);
      // 集客チャネル区分
      setChannelKbn(data['channelkbn']);
      // 集客チャネル
      setChannelCd(data['channel']);
      // 工事種別
      setKojiSyu(data['kojisyu']);
      // ラベル
      setLabel(data['label']);
      // 工程
      setProcess(data['process']);
      // 事業
      setJigyo(data['jigyo']);
      // ダッシュボードグループ
      setDashboardGroup(data['dashboardGroup']);
      // 工事情報ステータス
      setConstructionStatus(data['constructionStatus']);
      // 前受金の比率情報
      setMaeukeRates(data['maeuke_rates']);
      // 受付区分
      setUkeType(data['uketype']);
      // 特殊郵便番号
      setOriginalPost(data['originalPost']);
      // ロボット工事種類
      setRobotTypes(data['robotTypes'] || []);
    });
  }, []);

  // マスタの再読み込み処理
  const reloadMaster = () => {
    restApi.get('/api/master/list', (data) => {
      // 社員
      setStaff(data['staff']);
      // 営業担当ソート順
      setSalesStaff(data['salesStaff']);
      // 現場担当ソート順
      setGenbaStaff(data['genbaStaff']);
      // プランナー（全社員を選択可能に変更）
      // setPlaner(data["staff"].filter(s => s["kbn"] === '1'));
      setPlaner(data['staff']);
      // ハウスメーカ
      setHouseMaker(data['company']);
      // 集客チャネル区分
      setChannelKbn(data['channelkbn']);
      // 集客チャネル
      setChannelCd(data['channel']);
      // 工事種別
      setKojiSyu(data['kojisyu']);
      // ラベル
      setLabel(data['label']);
      // 工程
      setProcess(data['process']);
      // 事業
      setJigyo(data['jigyo']);
      // ダッシュボードグループ
      setDashboardGroup(data['dashboardGroup']);
      // 工事情報ステータス
      setConstructionStatus(data['constructionStatus']);
      // 前受金の比率情報
      setMaeukeRates(data['maeuke_rates']);
      // 受付区分
      setUkeType(data['uketype']);
      // 特殊郵便番号
      setOriginalPost(data['originalPost']);
      // ロボット工事種類
      setRobotTypes(data['robotTypes'] || []);
    });
  };

  return (
    <MasterContext.Provider
      value={{
        staff,
        salesStaff,
        genbaStaff,
        planer,
        houseMaker,
        channelKbn,
        channelCd,
        kojiSyu,
        label,
        process,
        jigyo,
        dashboardGroup,
        constructionStatus,
        reloadMaster,
        maeukeRates,
        ukeType,
        originalPost,
        robotTypes,
      }}
    >
      {children}
    </MasterContext.Provider>
  );
}

/**
 * マスタ情報を取得
 * @returns マスタ情報
 */
export function useMaster() {
  const context = useContext(MasterContext);
  if (context == undefined) {
    throw new Error('マスタ情報の取得に失敗しました。');
  }
  return context;
}
